import './index.css'
import {
  LayoutDashboard,
  List,
  CreditCard,
  BarChart3,
  Target,
  Settings,
  LogOut,
  Shield,
} from "lucide-react";
import type { SidebarProps, NavId } from "../../types";
import { supabase } from "../../lib/supabase";

interface NavItem {
  id: NavId;
  label: string;
  Icon: React.ElementType;
}

const NAV_ITEMS: NavItem[] = [
  { id: "overview", label: "Visão geral", Icon: LayoutDashboard },
  { id: "transactions", label: "Transações", Icon: List },
  { id: "cards", label: "Cartões", Icon: CreditCard },
  { id: "annual", label: "Anual", Icon: BarChart3 },
  { id: "goals", label: "Metas", Icon: Target },
  { id: "settings", label: "Configurações", Icon: Settings },
];

const AVATAR_COLORS = ["#2F8F5C", "#B43F30", "#3F6FB4", "#8F5C2F"];

function initial(name: string) {
  return name.trim().charAt(0).toUpperCase();
}

export default function Sidebar({ active, onNav, onSignOut, userName, householdName, planTier, memberCount = 1, partnerName, isAdmin }: SidebarProps) {
  const isCasal = planTier === "casal";

  const namesFromHousehold = isCasal && householdName
    ? householdName.split(/\s*&\s*/).map(n => n.trim()).filter(Boolean)
    : [];

  const members = isCasal
    ? (namesFromHousehold.length >= 2
        ? namesFromHousehold
        : memberCount >= 2
          ? [userName, partnerName ?? 'Parceiro']
          : [userName])
    : [userName];

  const displayName = isCasal
    ? (householdName ?? userName)
    : userName;

  return (
    <aside className="bc-sidebar">
      <div className="bc-brand">
        <img src="/logo-mark.svg" width="32" height="32" alt="" />
        <span className="bc-brand__word">BagCash</span>
      </div>

      <nav className="bc-nav" data-tour="sidebar-nav">
        {isAdmin ? (
          <button
            className={"bc-nav__item bc-nav__item--admin" + (active === "admin" ? " is-active" : "")}
            onClick={() => onNav("admin")}
          >
            <Shield size={18} />
            <span>Admin</span>
          </button>
        ) : (
          NAV_ITEMS.map(({ id, label, Icon }) => (
            <button
              key={id}
              className={"bc-nav__item" + (active === id ? " is-active" : "")}
              onClick={() => onNav(id)}
            >
              <Icon size={18} />
              <span>{label}</span>
            </button>
          ))
        )}
      </nav>

      <div className="bc-sidebar__footer">
        <div className="bc-couple" data-tour="plan-badge">
          {isCasal && <div className="bc-couple__title">Conta de casal</div>}
          <div className="bc-couple__row">
            {members.map((name, i) => (
              <div
                key={i}
                className="bc-avatar"
                style={{ background: AVATAR_COLORS[i % AVATAR_COLORS.length] }}
              >
                {initial(name)}
              </div>
            ))}
            <div className="bc-couple__name">{displayName}</div>
            {planTier === 'pro'   && <span className="bc-badge bc-badge--pro">Pro</span>}
            {planTier === 'casal' && <span className="bc-badge bc-badge--casal">Casal</span>}
          </div>
        </div>

        <button
          className="bc-nav__item"
          onClick={onSignOut ?? (() => supabase.auth.signOut())}
        >
          <LogOut size={18} />
          <span>Sair</span>
        </button>
      </div>
    </aside>
  );
}
